import React, { PropTypes } from 'react';
import { Glossary } from '../';
import { TermModal } from '../../components';

const App = ({ glossaryData, route, glossaryItem }) => {
  if (route === 'home') {
    return (
      <div>
        <Glossary glossary={glossaryData} route={route} />
      </div>
    );
  }
  return (
    <div>
      <Glossary glossary={glossaryData} route={route}>
        <TermModal route={route} {...glossaryItem} />
      </Glossary>
    </div>
  );
};

App.defaultProps = {
  glossaryItem: {},
  glossaryData: []
};

App.propTypes = {
  glossaryData: PropTypes.arrayOf(
    PropTypes.shape({
      term: PropTypes.string.isRequired,
      letter: PropTypes.string.isRequired,
      definition: PropTypes.string.isRequired,
      subitems: PropTypes.object
    })
  ),
  route: PropTypes.string.isRequired,
  glossaryItem: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/containers/App/App.js